/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/
import Vue from 'vue'
import Vuex from 'vuex'
import userModule, { UserState } from './modules/user'
import companyModule, { CompanyState } from './modules/company'
import loadingModule from './modules/loading'
import switchAccountModule from './modules/switchAccount'
import phoneInterceptCounterModule from './modules/phoneInterceptCounter'
import wpsIcon from '@assets/common/logo.png'

Vue.use(Vuex)
export interface State {
  HeadTitle: string
  HeadIcon: string
  HeadIconUrl: string
  AdminModal: boolean
  // UtmSource: string
  // ClientType: string
  HideComponents: Array<any>
  user: UserState
  // user: ReturnType<typeof userModule>['state']
  company: CompanyState
  registerLoginStatus: boolean
}
export default new Vuex.Store<State>({
  // @ts-ignore
  state: {
    HeadTitle: '',
    HeadIcon: wpsIcon,
    HeadIconUrl: '/',
    AdminModal: false,
    // UtmSource: '',
    // ClientType: 'pc',
    HideComponents: [],
    registerLoginStatus: true,
  },
  mutations: {
    HeadTitle: (state, v) => {
      state['HeadTitle'] = v
    },
    HeadIcon: (state, v) => {
      state['HeadIcon'] = v
    },
    HeadIconUrl: (state, v) => {
      state['HeadIconUrl'] = v
    },
    AdminModal: (state, v) => {
      state['AdminModal'] = v
    },
    // UtmSource: (state, v) => {
    //   state['UtmSource'] = v
    // },
    // ClientType: (state, v) => {
    //   state['ClientType'] = v
    // },
    HideComponents: (state, v) => {
      state['HideComponents'] = v
    },
    setRegisterLoginStatus: (state, v = false) => {
      state['registerLoginStatus'] = v
    },
  },
  actions: {
    HeadTitle: ({ commit }, val) => {
      commit('HeadTitle', val)
    },
    HeadIcon: ({ commit }, val) => {
      commit('HeadIcon', val)
    },
    HeadIconUrl: ({ commit }, val) => {
      commit('HeadIconUrl', val)
    },
    AdminModal: ({ commit }, val) => {
      commit('AdminModal', val)
    },
    // UtmSource: ({ commit }, val) => {
    //   commit('UtmSource', val)
    // },
    // ClientType: ({ commit }, val) => {
    //   commit('ClientType', val)
    // },
    HideComponents: ({ commit }, val) => {
      commit('HideComponents', val)
    },
    setRegisterLoginStatus: ({ commit }, val) => {
      commit('setRegisterLoginStatus', val)
    },
  },
  modules: {
    user: userModule(),
    company: companyModule,
    loading: loadingModule,
    switchAccount: switchAccountModule,
    phoneInterceptCounter: phoneInterceptCounterModule,
  },
})
